import { autoinject, inject, newInstance } from 'aurelia-dependency-injection';
import { DialogController } from 'aurelia-dialog';
import { Router } from 'aurelia-router';
import { ValidationControllerFactory, ValidationRules, ValidationController } from 'aurelia-validation';
import { BootstrapFormRenderer } from '../../services/bootstrap-form-renderer';
import { CustomerInfoStore, RegisterCustomerInputModel, RegisterAction } from '../../services/customer-info-store';



@autoinject
export class RegisterCustomer {
    private controller: ValidationController;
    
    constructor(@newInstance() factory: ValidationControllerFactory, private router: Router, 
        private dialogController: DialogController, private customerInfoStore: CustomerInfoStore) {
        this.controller = factory.createForCurrentScope();
    }

    
    id: string; 
    company: string;
    name: string;
    email: string;
    isProduction: boolean;
    environmentType: string;
    gdprConsentGiven: boolean = false;
    signedUpForNewsLetter: boolean = false; // Allowed within GDPR to checked by default, but we choose to have false as default value
    organizationName: string = "";
    organizationId: string = "";
    isRequesting = false;
    renderer: BootstrapFormRenderer = null;
    registerAction: RegisterAction = RegisterAction.Register;
    duplicateCustomerError: string = null; // Used to show error message if customer with the given name already exists

    activate(model: RegisterCustomerInputModel) {
        console.log("Activate RegisterCustomer", model);

        this.organizationId = model.organizationId;
        this.organizationName = model.organizationName;
        
        if(model.registerAction === RegisterAction.Update){
            this.id = model.id;
            this.company = model.company;
            this.name = model.name;
            this.gdprConsentGiven = model.gdprConsentGiven;
            this.email = model.email;
            this.environmentType = model.isProduction ? "production" : "nonproduction";
            this.signedUpForNewsLetter = model.signedUpForNewsLetter;
            this.registerAction = model.registerAction;
        }
    }


    bind() {
        console.log('RegisterCustomer.bind');

        this.renderer = new BootstrapFormRenderer();
        this.controller.addRenderer(this.renderer);
    }
    unbind() {
        this.controller.removeRenderer(this.renderer);
    }

    async register() {
        console.log('RegisterCustomer.register');
        let keepDialogOpen = false;

        this.duplicateCustomerError = null; // Reset the error message

        // Set isProduction
        this.isProduction = this.environmentType === "production";

        if (this.isRequesting) {
            return;
        }
        this.isRequesting = true;

        const validationResult = await this.controller.validate();

        if (validationResult.valid === false) {
            console.log(`form not valid`, validationResult.results);
            this.isRequesting = false;
            return;
        }

        try {

            await this.customerInfoStore.register(this);

        } catch (e) {

            if (e && e.status === 409) {
                //HTTP 409 conflict means the organization already exists, show friendly error message
                this.duplicateCustomerError = `A customer with name '${this.company}' already exists.`;
                console.error(this.duplicateCustomerError);
                keepDialogOpen = true; // Keep the dialog open to allow user to correct the input (duplicateCustomerError will be displayed in the form)
            }
            else {
                let errorMessage: string = e instanceof Error
                    ? e.message
                    : String(e);

                this.router.navigateToRoute('error', { errorMessage });
            }
        }
        finally {
            this.isRequesting = false;
            if (!keepDialogOpen) {
                this.dialogController.close(true);
            }
        }
    }
}


ValidationRules
    .ensure((p: RegisterCustomer) => p.company).required()
    .ensure((p: RegisterCustomer) => p.name).required()
    .ensure((p: RegisterCustomer) => p.gdprConsentGiven).required()
    .ensure((p: RegisterCustomer) => p.email).required().email()
    .ensure((p: RegisterCustomer) => p.environmentType).required()
    .on(RegisterCustomer);


// WEBPACK FOOTER //
// ./ClientApp/app/components/register-organization/register-customer.ts